import React from 'react'
import './StepTwo.css'
import { NavLink } from 'react-router-dom';
import steptwologo from '../../../assets/img/step2.svg'
import logo from '../../../assets/img/logo.svg'
import { Col, Row, Input, Button, Checkbox } from 'antd';
import { CheckOutlined } from '@ant-design/icons';

export const SteptwoLeft = ({ stepTwoDone }) => {
    return(
        <Col className={`gutter-row signup_left ${stepTwoDone === true ? 'show_two' : 'hide_two'}`} xs = {{ span: 24 }} sm = {{ span: 8 }} md = {{ span: 8 }} lg = {{ span: 6 }} xl ={{ span: 6 }}>
            <div className="playarone_logo">
                <NavLink exact to="/" >
                    <img src={logo} alt="" />
                </NavLink>
            </div>

            <div className="signup_left_info_s2">
                <img src={steptwologo} alt="" />
                <h4>Play and earn anytime</h4>
                <h3>Finish setting up your account</h3>
                <p>PlayarOne is personalised for you. Start 
                by creating your account to join or 
                create any games at any time.</p>

                <ul>
                    <li> 
                        <p>
                            <div style={{ width: '8%' }}>
                                <CheckOutlined />
                            </div> 
                            <div  style={{ width: '92%' }}>
                                Create and join 1 vs 1 Games
                            </div>
                           
                        </p>
                    </li>
                    <li> 
                        <p>
                            <div style={{ width: '8%' }}>
                                <CheckOutlined />
                            </div> 
                            <div  style={{ width: '92%' }}>
                                Create and join online tournaments
                            </div>
                        </p>
                    </li>
                    <li> 
                        <p>
                            <div style={{ width: '8%' }}>
                                <CheckOutlined />
                            </div>
                            <div  style={{ width: '92%' }}>
                                Invite your community members or friends privately to join Games
                            </div>
                        </p>
                    </li>
                </ul>
            </div>
        </Col>
    );
}

export const SteptwoRight = ({ twoDone, stepTwoDone }) => {
    return(
        <Col className={`gutter-row signup_right ${stepTwoDone === true ? 'show_two' : 'hide_two'}`} xs = {{ span: 24 }} sm = {{ span: 16 }} md = {{ span: 16 }} lg = {{ span: 18 }} xl ={{ span: 18 }}>
            <div className="signin_link">
                <NavLink exact to="/sign-in">
                    <p>Already have an account? <span>Sign In</span></p>
                </NavLink>
            </div>

            <div className="signup_right_info_s2">
                <p>Create your account</p>
                <Row gutter={[16, 24]} className="signup_row">
                    <Col className="gutter-row signup_inputs" xs = {{ span: 24 }} sm = {{ span: 20 }} md = {{ span: 16 }} lg = {{ span: 12 }} xl ={{ span: 12 }}>
                        
                        <Input placeholder="Email" />
                        <Input.Password placeholder="Password" />
                        <Checkbox>Do not email me PlayarOne special offers.</Checkbox>
                        <Button type="primary" onClick={twoDone}>CONTINUE</Button>
                        <div className="signup_input_bottom">
                            <p>By creating an account, you agree with our Terms of Use, Privacy Policy, our default Cookie Preferences.</p>
                        </div>
                    
                    </Col>
                </Row>
            </div>
        </Col>
    );
}